import React, { memo, useEffect, useState } from 'react';

import { useDebounce } from 'react-use';

import { Slider, withStyles } from '@material-ui/core';

import Copy from '../Copy';

const PrettoSlider = withStyles({
  root: {
    color: '#233841',
    height: 6,
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#233841',
    marginTop: -3,
    marginLeft: -6,
    '&$active': {
      boxShadow: '0 0 0 6px rgba(35, 56, 65, 0.16) !important',
    },
    '&:focus, &:hover': {
      boxShadow: '0 0 0 4px rgba(35, 56, 65, 0.16)',
    },
    boxShadow: '0 0 0 4px rgba(35, 56, 65, 0.16)',
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  rail: {
    height: 6,
    borderRadius: 4,
    backgroundColor: '#DAE2E6',
    opacity: 1,
  },
})(Slider);

const RangeSliderInput = ({
  label,
  min,
  max,
  value = min,
  suffix,
  onChange,
  step = 1,
}: {
  label?: React.ReactNode;
  min: number;
  max: number;
  value: number | undefined;
  suffix?: string;
  onChange: (value: number) => void;
  step?: number;
}) => {
  const [internalValue, setInternalValue] = useState(value ?? min);

  useDebounce(
    () => {
      if (value !== internalValue) onChange(internalValue);
    },
    300,
    [internalValue],
  );

  useEffect(() => {
    if (value !== undefined && value !== internalValue) setInternalValue(value);
  }, [value]);

  return (
    <div className="w-full">
      {label && (
        <Copy className="ml-2 mb-4 text-v2blueGray-600" type="copy2">
          {label}
        </Copy>
      )}

      <div className="flex items-center gap-4 bg-v2blueGray-0 px-4 h-[36px] rounded-lg">
        <PrettoSlider
          className="w-[80%]"
          value={internalValue}
          min={min}
          max={max}
          step={step}
          onChange={(e, newValue) => {
            if (typeof newValue === 'number') setInternalValue(newValue);
          }}
          valueLabelDisplay="off"
          aria-labelledby="input-slider"
        />

        <Copy className="text-v2blueGray-600 w-[20%] text-right">
          {internalValue}
          {suffix}
        </Copy>
      </div>
    </div>
  );
};

export default memo(RangeSliderInput);
